import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'

@Injectable()
export class PlaySessionApi {
  apiPath(sessionId: string = '') {
    return `play_sessions/${sessionId}`
  }

  constructor(
    private api: LectureApiBase,
  ) { }

  create(params: any) {
    return this.api.post(this.apiPath(''), params)
  }

  leave(sessionId: string) {
    return this.api.put(`${this.apiPath(sessionId)}/leave`, null)
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-session.ts